import { render, staticRenderFns } from "./monthSaleAmountColumn.vue?vue&type=template&id=01bb388c"
import script from "./monthSaleAmountColumn.vue?vue&type=script&lang=js"
export * from "./monthSaleAmountColumn.vue?vue&type=script&lang=js"
import style0 from "./monthSaleAmountColumn.vue?vue&type=style&index=0&id=01bb388c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports